import { MapPinLine } from "@phosphor-icons/react";

export default function AnnouncementBanner() {
  return (
    <div
      data-testid="announcement-banner"
      className="fixed top-0 inset-x-0 z-[60] bg-[#C25934] text-[#FDFBF7] border-b border-[#A04728] shadow-[0_2px_12px_rgba(194,89,52,0.35)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 md:py-5 flex items-center justify-center gap-3 text-center">
        <MapPinLine size={22} weight="fill" className="text-[#FDFBF7] flex-shrink-0 hidden sm:block ember-glow" />
        <p className="text-sm sm:text-base md:text-lg font-semibold tracking-wide">
          <span className="font-accent text-lg sm:text-xl md:text-2xl text-[#FDFBF7] mr-2">a note —</span>
          We are currently looking for a space to run operations.
          <a
            href="#contact"
            data-testid="banner-contact-link"
            className="ml-2 underline underline-offset-4 decoration-2 text-[#FDFBF7] hover:text-[#1F1A17] transition-colors"
          >
            Can you help?
          </a>
        </p>
      </div>
    </div>
  );
}
